import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { redirectToPublicOrigin } from "./canonicalOrigin";
import "./i18n/init";
import "./styles/globals.css";

// Op een ander adres dan het publieke? Dan door (zie canonicalOrigin.ts).
void redirectToPublicOrigin();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
